export default __webpack_public_path__ + "static/media/VO_HOW_STEPS_MOBILE1.0fad16e2.svg";